import { Asset } from '@/api/generatedApi';
import { useDeleteAsset } from '@/hooks/api/assets/useDeleteAsset';
import { getAssetFileName, getAssetName } from '@/utils/assets';
import { DeleteModal } from './DeleteModal';
import InsertDriveFileIcon from '@mui/icons-material/InsertDriveFile';
import { Box, Typography } from '@mui/material';

export const DeleteAssetModal = ({
  isOpen,
  onClose,
  onDelete,
  asset,
}: {
  isOpen: boolean;
  onClose: () => void;
  onDelete: () => void;
  asset: Asset;
}) => {
  return (
    asset?.id && (
      <DeleteModal
        title='Delete Asset'
        isOpen={isOpen}
        onClose={onClose}
        useHook={useDeleteAsset}
        hookParams={{ asset }}
        item={{ assetId: asset.id }}
        itemName={getAssetName(asset)}
        onConfirm={onDelete}
      >
        <Box
          sx={{
            border: 1,
            borderColor: 'divider',
            borderRadius: 1,
            p: 1,
          }}
        >
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, py: 0.5 }}>
            <InsertDriveFileIcon sx={{ fontSize: 20, color: 'text.secondary' }} />
            <Typography variant='body2' noWrap>
              {getAssetFileName(asset)}
            </Typography>
          </Box>
        </Box>
      </DeleteModal>
    )
  );
};
